import { TbaRangeResult } from '../tba-range-result';

export class DiscussRangeResultsModalPayload {
  tbaRangeResult: TbaRangeResult;
}
